/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.server.settings";

export { $nsid };

/** Record containing user settings for a particular Streamplace node */
type Main = { $type: "place.stream.server.settings";

  /**
   * Whether this node may archive your livestream for improving the service
   */
  "debugRecording"?:boolean;

  /**
   * Whether this node should record your livestreams into VODs that you can publish
   */
  "livestreamRecording"?:boolean;

  /**
   * Whether this node should publish the VOD of each of your recorded livestreams as soon as it ends
   */
  "autoPublishVods"?:boolean };

export type { Main };

/** Record containing user settings for a particular Streamplace node */
const main = /*#__PURE__*/ l.record<"any", Main>("any", $nsid, /*#__PURE__*/ l.object({"debugRecording":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"livestreamRecording":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"autoPublishVods":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean())}));

export { main };

export const $type = $nsid;
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
